var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.08049 11.0667C1.48407 11.4703 2.13841 11.4703 2.542 11.0667L6.29578 7.31296C7.07683 6.53192 7.07683 5.26558 6.29578 4.48454L2.54199 0.730754C2.13841 0.327169 1.48407 0.32717 1.08049 0.730754C0.676901 1.13434 0.676902 1.78868 1.08049 2.19226L3.37276 4.48454C4.15381 5.26558 4.15381 6.53191 3.37276 7.31296L1.08049 9.60524C0.676901 10.0088 0.676901 10.6632 1.08049 11.0667Z",
    fill: "#BDBDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.5,
    height: 12,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.cb41c914ad1db574f20392babfcf2e24.svg";
export { ForwardRef as ReactComponent };